import { useMemo } from "react";
import dayjs from "dayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { pickersLayoutClasses } from "@mui/x-date-pickers/PickersLayout";
import { multiSectionDigitalClockSectionClasses } from "@mui/x-date-pickers/MultiSectionDigitalClock";
import { PickersPtBr } from "./PickersPtBr";
import { textFieldDoCampo, type CampoPickerProps } from "./campoPicker";

const HORA = /^([01]\d|2[0-3]):[0-5]\d$/;

// Na janela, a barra Cancelar/OK é mais larga que as colunas de hora e minuto, e a sobra caía
// numa coluna vazia à esquerda. As colunas passam a ocupar a largura toda, dividida entre elas.
const layoutSemSobra = {
  [`& .${pickersLayoutClasses.contentWrapper}`]: { gridColumn: "1 / 4" },
  [`& .${multiSectionDigitalClockSectionClasses.root}`]: { flex: 1 },
  [`& .${multiSectionDigitalClockSectionClasses.item}`]: { width: "auto" },
};

// Hora "HH:MM" em 24h, com o relógio do MUI em pt-br. O <input type="time"> nativo segue o
// idioma do navegador e pode sair em AM/PM. Hora incompleta chega como "".
export function HoraField(props: CampoPickerProps) {
  const { label, value, onChange, disabled } = props;
  const data = useMemo(() => (HORA.test(value) ? dayjs(`2000-01-01T${value}`) : null), [value]);
  return (
    <PickersPtBr>
      <TimePicker
        label={label}
        ampm={false}
        value={data}
        disabled={disabled}
        onChange={(d) => onChange(d?.isValid() ? d.format("HH:mm") : "")}
        slotProps={{ layout: { sx: layoutSemSobra }, textField: textFieldDoCampo(props) }}
      />
    </PickersPtBr>
  );
}
